import React, { Fragment, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { PackageCard, SelectFieldOne, CheckBox, TextInputFixedLabel, PhoneInputField, } from "master-react-lib";


import LocalAtmRoundedIcon from '@material-ui/icons/LocalAtmRounded';
import CreditCardRoundedIcon from '@material-ui/icons/CreditCardRounded';
import ScheduleRoundedIcon from '@material-ui/icons/ScheduleRounded';
import cvvIcon from '../../assets/QuestionIcon.svg'

import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import './OrderForm.css'
import { useSelector, useDispatch } from 'react-redux'
import { setPaymentInfo } from '../../features/counter/counterSlice'
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import Tooltip from '@material-ui/core/Tooltip';


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `wrapped-tab-${index}`,
        'aria-controls': `wrapped-tabpanel-${index}`,
    };
}








const Payment = (props) => {

    const pInfo = useSelector((state) => state.counter.paymentInfo)

    const rInfo = useSelector((state) => state.counter.requesterInfo)

    const dispatch = useDispatch()

    const cardFunction = (prop) => (value) => {
        // console.log(prop );
        if (prop == 'card') {
            setshowCardInformation(true);
            setshowPayCheck(false);
            setPayLater(false);
            props.setbuttonDisabled( true );

        } else if (prop == 'check') {
            setshowCardInformation(false);
            setshowPayCheck(true);
            setPayLater(false);
            props.setbuttonDisabled( false );

        } else {
            setshowCardInformation(false);
            setshowPayCheck(false);
            setPayLater(true);
            props.setbuttonDisabled( false );
        }

        setValues({
            ...values,
            ['method']: prop
        });
        dispatch(setPaymentInfo(values));

        props.setPaymentInfo({
            ...values,
            ['method']: prop
        });
    };

    const [showCardInformation, setshowCardInformation] = useState(true);

    const setPhoneNumber = (phone, counry) => () => {
        setValues({
            ...values,
            ['phone']: phone
        });

        dispatch(setPaymentInfo(values));

        props.setPaymentInfo({
            ...values,
            ['phone']: phone
        });
    };

    const selectdata = [
        { value: "AL", select: "Alabama" }, { value: "AK", select: "Alaska" }, { value: "AS", select: "American Samoa" }, { value: "AZ", select: "Arizona" }, { value: "AR", select: "Arkansas" }, { value: "CA", select: "California" }, { value: "CO", select: "Colorado" }, { value: "CT", select: "Connecticut" }, { value: "DE", select: "Delaware" }, { value: "DC", select: "District Of Columbia" }, { value: "FM", select: "Federated States Of Micronesia" }, { value: "FL", select: "Florida" }, { value: "GA", select: "Georgia" }, { value: "GU", select: "Guam" }, { value: "HI", select: "Hawaii" }, { value: "ID", select: "Idaho" }, { value: "IL", select: "Illinois" }, { value: "IN", select: "Indiana" }, { value: "IA", select: "Iowa" }, { value: "KS", select: "Kansas" }, { value: "KY", select: "Kentucky" }, { value: "LA", select: "Louisiana" }, { value: "ME", select: "Maine" }, { value: "MH", select: "Marshall Islands" }, { value: "MD", select: "Maryland" }, { value: "MA", select: "Massachusetts" }, { value: "MI", select: "Michigan" }, { value: "MN", select: "Minnesota" }, { value: "MS", select: "Mississippi" }, { value: "MO", select: "Missouri" }, { value: "MT", select: "Montana" }, { value: "NE", select: "Nebraska" }, { value: "NV", select: "Nevada" }, { value: "NH", select: "New Hampshire" }, { value: "NJ", select: "New Jersey" }, { value: "NM", select: "New Mexico" }, { value: "NY", select: "New York" }, { value: "NC", select: "North Carolina" }, { value: "ND", select: "North Dakota" }, { value: "MP", select: "Northern Mariana Islands" }, { value: "OH", select: "Ohio" }, { value: "OK", select: "Oklahoma" }, { value: "OR", select: "Oregon" }, { value: "PW", select: "Palau" }, { value: "PA", select: "Pennsylvania" }, { value: "PR", select: "Puerto Rico" }, { value: "RI", select: "Rhode Island" }, { value: "SC", select: "South Carolina" }, { value: "SD", select: "South Dakota" }, { value: "TN", select: "Tennessee" }, { value: "TX", select: "Texas" }, { value: "UT", select: "Utah" }, { value: "VT", select: "Vermont" }, { value: "VI", select: "Virgin Islands" }, { value: "VA", select: "Virginia" }, { value: "WA", select: "Washington" }, { value: "WV", select: "West Virginia" }, { value: "WI", select: "Wisconsin" }, { value: "WY", select: "Wyoming" }
    ];

    const [values, setValues] = useState(pInfo);

    // const [errorValues, setErrorValues] = useState(  );
    //     postalCode: true, 
    //     city: true ,
    //     streetAddress: true
    // });

    const handleChange = (prop) => (event) => {
        setValues({
            ...values,
            [prop]: event.target.value
        });

        console.log(values);

        dispatch(setPaymentInfo({
            ...values,
            [prop]: event.target.value
        }));
        props.setPaymentInfo({
            ...values,
            [prop]: event.target.value
        });

        
        // setErrorValues( {
        //     ...errorValues, 
        //     [prop]: event.target.value.length < 1 
        // });

        billingAddressValidation();

    };

    const billingAddressValidation = () =>{
        let db = false ; 

        if(  values.nameOnCard.length > 0 ){
            db = false ;             
        }else{
            db = true ; 
        }

        // console.log( values.billingAddressSameAsShipping )

        // if( showBilling ){
        //     console.log("billingAddressSameAsShipping")
        // }else{
        //     if(  values.streetAddress.length > 0 && values.city.length > 0 && values.postalCode.length > 0 && values.nameOnCard.length > 0 ){
        //         db = false ; 
        //         console.log('all billing fields')
        //     }else{
        //         db = true ;  
        //         console.log('not filled')
        //     }
        // }
        props.setbuttonDisabled( db );
        return true; 
    }

    const handleExpDate = (e) => {
        // ignore invalid input
        if (!/^\d{0,2}\/?\d{0,2}$/.test(e.target.value)) {
            return
        }
        let input = e.target.value
        if (/^\d{3,}$/.test(input)) {
            input = input.match(new RegExp('.{1,2}', 'g')).join('/')
        }
        const [expMonth, expYear] = input.split('/')
        if (expMonth > 12) return
        const expFullYear = '20' + expYear
        const date = new Date()
        setexpError(
            expFullYear.length === 4 && expFullYear < date.getFullYear()
        )
        //   expError:  && 'Invalid exp date'
        // })
        if (+expFullYear === date.getFullYear()) {
            setexpError(
                expMonth < date.getMonth() + 1
            )
            //     expError:  && 'Invalid exp date'
            //   })
        }
        // this.setState({
        //   expDate: input,
        //   expMonth: Number(expMonth),
        //   expYear: Number(expYear)
        // })
        setexpYear(Number(expYear));

        setValues({
            ...values,
            ['expiration']: input

        });

        // console.log( values );

        dispatch(setPaymentInfo({
            ...values,
            ['expiration']: input
        }));

        props.setPaymentInfo({
            ...values,
            ['expiration']: input
        });
    }

    const [expError, setexpError] = useState(false);
    const [expYearinExpiration, setexpYear] = useState('');

    const validateExp = (prop) => (e) => {
        // const { expYear, expError } = this.state
        if (!expError) {
            setexpError(
                expYearinExpiration.toString().length !== 2
            )
        }
    }

    const [showBilling, setshowBilling] = useState(false);

    const [securityCodeError, setsecurityCodeError] = useState( false );

    const handleCvv = (e) => {
        const cardNumber = values.cardNumber;
        const cvvCode = e.target.value
        if (cvvCode.length > 2 && (cardNumber?.startsWith('37') ? cvvCode.length > 4 : cvvCode.length > 3)) return
        // this.setState({ cvvCode: e.target.value })

        if( cardNumber?.startsWith('37') ){
            if( cvvCode.length < 4){
                setsecurityCodeError( true );
            }else{
                setsecurityCodeError( false );
            }
        }else{
            if( cvvCode.length < 3){
                setsecurityCodeError( true );
            }else{
                setsecurityCodeError( false );
            }
        }

        setValues({
            ...values,
            ['securityCode']: cvvCode

        });

        // console.log( values );

        dispatch(setPaymentInfo({
            ...values,
            ['securityCode']: cvvCode
        }));
        props.setPaymentInfo({
            ...values,
            ['securityCode']: cvvCode
        });
    }

    const creditCardFormat = (card) => {

        if (!card) return card
        if (card[0] === '3') {

            let str = card;
            let str2;
            if (str.length === 4) {
                str = str + ' '
                return str
            }
            else if (str.length === 10) {
                str = str + ''
                return str
            }
            else if (str.length === 11) {
                str = str + ' '
                return str
            }
            // else if(str.length === 18){
            //   return false
            // }

            else {
                return str
            }

        }

        const cardWithoutSpace = card.replace(/\s/g, '')
        const cardTemp = cardWithoutSpace.match(/.{1,4}/g)
        return cardTemp.join(' ')
    }

    //---- Date Field ---//
    const [selectedDate, setSelectedDate] = React.useState(new Date());
    const handleDateChange = (date) => {
        setSelectedDate(date);
        setValues({
            ...values,
            ['payLaterDate']: date
        });
        dispatch(setPaymentInfo({
            ...values,
            ['payLaterDate']: date
        }));
        props.setPaymentInfo({
            ...values,
            ['payLaterDate']: date
        });
    };

    const [showPayCheck, setshowPayCheck] = useState(false);
    const [showPayLater, setPayLater] = useState(false);


    const [cardError, setcardError] = useState(false);

    const [value, setValue] = React.useState(0);
    const handleChangeTabs = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className="PaymentContainer">
            <Grid container spacing={2}>

                <Grid item md={12} sm={12} xs={12}>
                    <div className='checkOutTabsContainer'>
                        <Tabs value={value} onChange={handleChangeTabs} aria-label="simple tabs example">
                            <Tab label="Credit Card" icon={<><CreditCardRoundedIcon /> <CheckCircleRoundedIcon className='TabcheckIcon' /></>} {...a11yProps(0)} onClick={cardFunction('card')} />
                            <Tab label="Pay Check" icon={<><LocalAtmRoundedIcon /> <CheckCircleRoundedIcon className='TabcheckIcon' /></>} {...a11yProps(1)} onClick={cardFunction('check')} />
                            <Tab label="Pay Later" icon={<><ScheduleRoundedIcon /> <CheckCircleRoundedIcon className='TabcheckIcon' /></>} {...a11yProps(2)} onClick={cardFunction('payLater')} />
                        </Tabs>
                    </div>

                    <TabPanel value={value} index={0}>

                        <div className='CardinfoContainer'>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <div className="formSectionTitleIn">Card information</div>
                                </Grid>
                                <Grid item md={6} xs={12}>

                                    <TextInputFixedLabel
                                        label="Card number"
                                        labelStatus={true}
                                        onBlur={() => {
                                            if (values.cardNumber.length !== 0) {
                                                let isError = values.cardNumber.length < 14
                                                setcardError(isError);
                                            }
                                        }}
                                        HelpertextStatus={true}
                                        //error="error"
                                        Errormessage="Card number not valid"
                                        errortextStatus={cardError}
                                        count={false}
                                        countStatus={false}
                                        tooltipStatus={false}
                                        placeholder="Card number"
                                        value={values.cardNumber}
                                        // onChange={handleChange('cardNumber')}
                                        onChange={(e) => {
                                            if (e.target.value.replace(/\s/g, '').match(/^\d+$/)) {
                                                const card = creditCardFormat(e.target.value);
                                                let cardWithoutSpace = card.replace(/\s/g, '')

                                                cardWithoutSpace = cardWithoutSpace.length > 16 ? values.cardNumber : card;

                                                let cvvCode = !e.target.value?.startsWith('37') && values.securityCode.length >= 4 ? values.securityCode.slice(0, 3) : values.securityCode;

                                                setValues({
                                                    ...values,
                                                    ['cardNumber']: cardWithoutSpace,
                                                    ['securityCode']: cvvCode,
                                                });

                                                props.setPaymentInfo({
                                                    ...values,
                                                    ['cardNumber']: cardWithoutSpace,
                                                    ['securityCode']: cvvCode,
                                                });

                                            } else if (!e.target.value) {
                                                setValues({
                                                    ...values,
                                                    ['cardNumber']: '',
                                                });

                                                props.setPaymentInfo({
                                                    ...values,
                                                    ['cardNumber']: ''
                                                });
                                            }
                                        }}
                                    />

                                </Grid>

                                <Grid item md={3} xs={12}>
                                    <TextInputFixedLabel
                                        label="Expiration"
                                        labelStatus={true}
                                        helpertext="Helper text"
                                        value={values.expiration}
                                        Errormessage="Please enter a valid expiration date."
                                        errortextStatus={expError}
                                        count={false}
                                        countStatus={false}
                                        tooltipStatus={false}
                                        placeholder="MM/YY"
                                        onChange={handleExpDate}
                                        //error="error"
                                        onBlur={() => validateExp()}
                                    />
                                </Grid>

                                <Grid item md={3} xs={12}>
                                    <div className="field_box">
                                        <TextInputFixedLabel
                                            label="Security code"
                                            labelStatus={true}
                                            placeholder="CVV"
                                            helpertext="Helper text"
                                            value={values.securityCode}
                                            Errormessage="Please enter a valid security code."
                                            error={securityCodeError}
                                            errortextStatus={securityCodeError}
                                            count={false}
                                            countStatus={false}
                                            tooltipStatus={false}
                                            onChange={(e) => {
                                                const numRegx = /^[0-9]*$/
                                                if (e.target.value.match(numRegx)) {
                                                    handleCvv(e)
                                                }else{
                                                    setsecurityCodeError( false )
                                                }
                                            }}
                                        //error="error"
                                        />
                                        <Tooltip title="CVV is the last 3 digits on the back. In American Express, it is a 4 digits code in the front of the credit card" placement="top-start">
                                            <img className='cvvICon' src={cvvIcon} width="30px" alt="card img" />
                                        </Tooltip>
                                    </div>
                                </Grid>


                                <Grid item md={12} xs={12}>
                                    <TextInputFixedLabel
                                        label="Name on card"
                                        labelStatus={true}
                                        // helpertext="Helper text"
                                        HelpertextStatus={false}
                                        Errormessage="Error message"
                                        errortextStatus={false}
                                        count={false}
                                        countStatus={false}
                                        tooltipStatus={false}
                                        onChange={handleChange('nameOnCard')}
                                    //error="error"

                                    />
                                </Grid>


                                {/* <Grid item md={6} xs={12}>
                                            <PhoneInputField
                                                labelFixed="Phone number"
                                                phoneInputVariant={"materialui"} // default, materialui, underlineInput, underlineWithFlag
                                                country={'us'}
                                                value={values.phone}
                                                countryCodeEditable={false}
                                                onChange={(phone, country) => setPhoneNumber(phone, country)}
                                                onBlur={() => console.log("onBlur")}
                                                onKeyDown={(e) => console.log("onKeyDown", e.target.value)}
                                                variant="outlined"
                                                onlyCountries={["us", "ca", "gb", "my"]}
                                                containerStyle={{}}
                                                buttonStyle={{}}
                                                inputStyle={{
                                                    marginLeft: "0px",
                                                    height: "40px",
                                                    width: "100%",
                                                    fontFamily: "Roboto-Regular",
                                                    fontSize: "16px",
                                                }}
                                                containerClass={{}}
                                                errorText={"Phone number is required"}
                                                error={false}
                                                errorStyles={{ marginBottom: "5px" }}
                                                autoFormat={true}
                                                disableDropdown={false}
                                                disabled={false}
                                                disableCountryCode={false}
                                                enableSearch={false}
                                                disableSearchIcon={false}
                                                placeholder={""}
                                                inputProps={{}}
                                                //labelFixed="Phone number"
                                                LabelStatus={true}
                                                helpertext="In case of delivery questions"


                                            />
                                        </Grid> */}

                                <Grid item xs={12}>
                                    <div className="formSectionTitleIn">Billing address</div>
                                </Grid>

                                <Grid item xs={12} md={12}>
                                    <CheckBox
                                        label="Same as shipping address"
                                        checked={!showBilling}
                                        onChange={(e) => {
                                            // console.log('hi')
                                            if (showBilling) {
                                                setshowBilling(false);
                                            } else {
                                                setshowBilling(true);
                                            }

                                            

                                            setValues({
                                                ...values,
                                                ['billingAddressSameAsShipping']: !showBilling,
                                            });

                                            props.setPaymentInfo({
                                                ...values,
                                                ['billingAddressSameAsShipping']: !showBilling
                                            });

                                            billingAddressValidation();

                                        }}
                                    />

                                </Grid>

                                {!showBilling && (
                                    <Grid item xs={12}>
                                        <div className="FormDetailsContainerDtl BlAddress">
                                            <p>{rInfo.shippingFloorNumber} {rInfo.shippingStreetAddress}</p>
                                            <p> {rInfo.shippingCity}, {rInfo.shippingState} {rInfo.shippingPostalCode}</p>
                                        </div>
                                    </Grid>
                                )}

                                {showBilling && (
                                    <div className='PaymentformContainer'>
                                        <Grid container spacing={2}>
                                            <Grid item md={8} xs={12}>
                                                <TextInputFixedLabel
                                                    label="Billing address"
                                                    labelStatus={true}
                                                    // helpertext="Helper text"
                                                    HelpertextStatus={false}
                                                    Errormessage="Provide billing address"
                                                    errortextStatus={props.errorValues.streetAddress}
                                                    count={false}
                                                    countStatus={false}
                                                    tooltipStatus={false}
                                                    value={values.streetAddress}
                                                    onChange={handleChange('streetAddress')}
                                                    error={props.errorValues.streetAddress}
                                                />
                                            </Grid>

                                            <Grid item md={4} xs={12}>
                                                <TextInputFixedLabel
                                                    label="Apt/Floor (Optional)"
                                                    labelStatus={true}
                                                    // helpertext="Helper text"
                                                    HelpertextStatus={false}
                                                    //Errormessage="Error message"
                                                    errortextStatus={false }
                                                    count={false}
                                                    countStatus={false}
                                                    tooltipStatus={false}
                                                    value={values.floorNumber}
                                                    onChange={handleChange('floorNumber')}
                                                    
                                                />
                                            </Grid>

                                            <Grid item md={4} xs={12}>
                                                <TextInputFixedLabel
                                                    label="City/Town"
                                                    labelStatus={true}
                                                    // helpertext="Helper text"
                                                    HelpertextStatus={false}
                                                    Errormessage="Enter city"
                                                    errortextStatus={props.errorValues.city}
                                                    count={false}
                                                    countStatus={false}
                                                    tooltipStatus={false}
                                                    value={values.city}
                                                    onChange={handleChange('city')}
                                                    error={props.errorValues.city}
                                                />
                                            </Grid>

                                            <Grid item md={4} xs={12}>
                                                <SelectFieldOne
                                                    label="State/Province"
                                                    selectdata={selectdata}
                                                    defaultValue={values.state}
                                                    handleChange={handleChange('state')}
                                                //error="error"
                                                />
                                            </Grid>

                                            <Grid item md={4} xs={12}>
                                                <TextInputFixedLabel
                                                    label="Zip/Postal code"
                                                    labelStatus={true}
                                                    errortextStatus={props.errorValues.postalCode}
                                                    count={false}
                                                    countStatus={false}
                                                    tooltipStatus={false}
                                                    value={values.postalCode}
                                                    onChange={handleChange('postalCode')}
                                                    error={props.errorValues.postalCode}
                                                />
                                            </Grid>
                                        </Grid>

                                    </div>
                                )}


                            </Grid>
                        </div>



                    </TabPanel>

                    <TabPanel value={value} index={1}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <div className="FormDetailsContainerDtl">
                                    <p className='textUpercase'>CHECK PAYABLE TO :</p>
                                    <h5>Al-Quran Dawah Center, Inc</h5>
                                    <p className='textUpercase'>MAIL THE CHECK TO:</p>
                                    <p>Al-Quran Dawah Center, Inc</p>
                                    <p>1033 Glenmore Ave. 4th Fl.</p>
                                    <p>Brooklyn, NY 11208</p>
                                </div>
                            </Grid>
                        </Grid>
                    </TabPanel>

                    <TabPanel value={value} index={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <div className="DatePickerContainer">
                                    <label class="input_label">Please select a date</label>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <Grid container justifyContent="space-around">
                                            <KeyboardDatePicker
                                                margin="normal"
                                                format="MM/dd/yyyy"
                                                value={selectedDate}
                                                onChange={handleDateChange}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                            />
                                        </Grid>
                                    </MuiPickersUtilsProvider>
                                    <div className='DatePickerHelperText'>Please call us at <span> (347) 951-6829</span> to confirm date and time to meet.</div>
                                </div>
                            </Grid>
                        </Grid>
                    </TabPanel>



                </Grid>

            </Grid>
        </div>
    )
}




export default Payment;